program fresnelhost;

{$mode objfpc}

{ Pas2js host page for the Fresnel WebAssembly demos. It shows a drop-down list
  of the available demos (from the JS variable demoList in demos.js) and loads
  the selected demo's <Name>.wasm onto the page. Selecting a demo reloads the
  page with ?demo=<Name> so every wasm module starts in a clean environment. }

uses
  BrowserConsole, BrowserApp, JS, Classes, SysUtils, Web, wasihostapp, wasienv,
  Fresnel.Simple.Pas2js.WasmAPI, wasizenfs, libzenfs, libzenfsdom, types,
  wasm.pas2js.timer;

var
  { The list of demo names, defined in demos.js. Each name maps to <Name>.wasm. }
  demoList : array of string; external name 'demoList';

type

  { TFresnelHostApplication }

  TFresnelHostApplication = class(TBrowserWASIHostApplication)
  Private
    FFresnelAPI : TWasmFresnelSimpleApi;
    FTimerAPI : TWasmTimerAPI;
    FS :TWASIZenFS;
    function SelectedDemo: string;
    procedure PopulateSelect;
    procedure DoSelectDemo(Event: TJSEvent);
    procedure SetupTabs;
    procedure SetupHeaderToggle;
    procedure DoTabClick(Event: TJSEvent);
    procedure DoToggleHeader(Event: TJSEvent);
    procedure OnAfterStart(Sender: TObject; aDescriptor: TWebAssemblyStartDescriptor);
  Public
    constructor Create(aOwner : TComponent); override;
    procedure DoRun; override;
    procedure RunWasm ; async;
    function LoadFiles: Integer; async;
    Property FresnelAPI : TWasmFresnelSimpleApi Read FFresnelAPI;
  end;

{ TFresnelHostApplication }

procedure TFresnelHostApplication.OnAfterStart(Sender: TObject; aDescriptor: TWebAssemblyStartDescriptor);
begin
  Writeln('Wasm initialized, control now goes to Javascript event loop');
  { Start the periodic tick that pumps ProcessMessages (async layout, repaint,
    animations). Without it, pending work is only pumped by input events. }
  FFresnelAPI.StartTimerTick;
end;

// Return the demo chosen in the ?demo= query parameter, or '' if none.
function TFresnelHostApplication.SelectedDemo: string;

var
  Params : TJSURLSearchParams;
  V : JSValue;

begin
  Params:=TJSURLSearchParams.New(window.location.search);
  V:=Params.get('demo');
  if isString(V) then
    Result:=String(V)
  else
    Result:='';
end;

// Called when the user picks a demo: reload the page with the new selection.
procedure TFresnelHostApplication.DoSelectDemo(Event: TJSEvent);

var
  Sel : TJSHTMLSelectElement;

begin
  Sel:=TJSHTMLSelectElement(GetHTMLElement('demoSelect'));
  if Sel.value='' then
    window.location.search:=''
  else
    window.location.search:='?demo='+Sel.value;
end;

// Fill the drop-down from demoList and mark the current selection.
procedure TFresnelHostApplication.PopulateSelect;

var
  Sel : TJSHTMLSelectElement;
  Opt : TJSHTMLOptionElement;
  Cur : String;
  I : Integer;

begin
  Sel:=TJSHTMLSelectElement(GetHTMLElement('demoSelect'));
  Cur:=SelectedDemo;
  Opt:=TJSHTMLOptionElement(document.createElement('option'));
  Opt.text:='-- select a demo --';
  Opt.value:='';
  Sel.add(Opt);
  for I:=0 to Length(demoList)-1 do
    begin
    Opt:=TJSHTMLOptionElement(document.createElement('option'));
    Opt.text:=demoList[I];
    Opt.value:=demoList[I];
    if demoList[I]=Cur then
      Opt.selected:=True;
    Sel.add(Opt);
    end;
  Sel.AddEventListener('change',@DoSelectDemo);
end;

// Wire the two tabs so clicking one shows its panel. Bulma has no tab behaviour.
procedure TFresnelHostApplication.SetupTabs;

var
  Tabs : TJSNodeList;
  I : Integer;

begin
  Tabs:=document.querySelectorAll('.tabs li');
  for I:=0 to Tabs.length-1 do
    TJSHTMLElement(Tabs[I]).AddEventListener('click',@DoTabClick);
end;

// A tab was clicked: make it the active tab and show its matching panel.
procedure TFresnelHostApplication.DoTabClick(Event: TJSEvent);

var
  Li : TJSHTMLElement;
  Nodes : TJSNodeList;
  I : Integer;

begin
  Li:=TJSHTMLElement(Event.currentTarget);
  Nodes:=document.querySelectorAll('.tabs li');
  for I:=0 to Nodes.length-1 do
    TJSHTMLElement(Nodes[I]).classList.remove('is-active');
  Nodes:=document.querySelectorAll('.tab-content');
  for I:=0 to Nodes.length-1 do
    TJSHTMLElement(Nodes[I]).classList.remove('is-active');
  Li.classList.add('is-active');
  document.getElementById(Li.getAttribute('data-tab')).classList.add('is-active');
end;

// Wire the button that collapses/expands the header.
procedure TFresnelHostApplication.SetupHeaderToggle;

begin
  GetHTMLElement('toggleTop').AddEventListener('click',@DoToggleHeader);
end;

// Toggle the header (title + demo selector) to give the tabs more room.
procedure TFresnelHostApplication.DoToggleHeader(Event: TJSEvent);

var
  Btn, Host : TJSHTMLElement;

begin
  Btn:=TJSHTMLElement(Event.currentTarget);
  Host:=TJSHTMLElement(document.querySelector('.host-container'));
  if Host.classList.toggle('collapsed') then
    Btn.innerHTML:='Show header &#9660;'
  else
    Btn.innerHTML:='Hide header &#9650;';
end;

constructor TFresnelHostApplication.Create(aOwner: TComponent);
begin
  inherited Create(aOwner);
  FFresnelApi:=TWasmFresnelSimpleApi.Create(WasiEnvironment);
  FFresnelAPI.LogAPICalls:=False;
  FFresnelAPI.UseWordColors:=True;
  FFresnelAPI.WindowsParentRoot:=TJSHTMLElement(document.getElementById('desktop'));
  FFresnelAPI.UseKeyMap:=True;
  FTimerAPI:=TWasmTimerAPI.Create(WasiEnvironment);
  RunEntryFunction:='_initialize';
  PopulateSelect;
  SetupTabs;
  SetupHeaderToggle;
end;

procedure TFresnelHostApplication.DoRun;

begin
  RunWasm;
end;

function TFresnelHostApplication.LoadFiles: Integer;

const
  Files : TStringDynArray =
       ('style1.css','style2.css','powered_by.png');
var
  Res: TPreLoadFilesResult;
  I : Integer;
begin
  result:=-1;
  try
    Res:=await (PreloadFilesIntoDirectory('/',Files));
  except
    on E : Exception do
      Writeln('Exception while loading files: ',E.Message);
    on JE : TJSError do
      Writeln('Exception while loading files: ',JE.Message);
  end;
  For I:=0 to Length(Res.failedurls)-1 do
    With Res.failedurls[i] do
      Writeln('Failed to preload file: ',url,' : ',error);
  Result:=res.loadcount;
end;

procedure TFresnelHostApplication.RunWasm;

var
  WasmModule : string;
  Demo : string;
  aCount : Integer;

begin
  Terminate;
  Demo:=SelectedDemo;
  if Demo='' then
    begin
    Writeln('No demo selected. Choose one from the list above.');
    Exit;
    end;
  await(tjsobject,  ZenFS.configure(
    new(
      ['mounts', new([
        '/', DomBackends.WebStorage
       ])
      ])
    )
  );
  FS:=TWASIZenFS.Create;
  WasiEnvironment.FS:=FS;
  aCount:=await(LoadFiles);
  Writeln('Loaded ',aCount,' files.');
  WasmModule:=Demo+'.wasm';
  Writeln('Loading and starting Webassembly module: ',WasmModule);
  StartWebAssembly(WasmModule,true,Nil,@OnAfterStart);
end;

var
  Application : TFresnelHostApplication;
begin
  ConsoleStyle:=DefaultCRTConsoleStyle;
  HookConsole;
  Application:=TFresnelHostApplication.Create(nil);
  Application.Initialize;
  Application.Run;
end.
